import React, { ReactNode, useCallback } from 'react';
import { BufferEditor } from '~/editor/BufferEditor/types.plate';
import { updateSlateErrorData } from '~/editor/error';
import getErrorBoundary from '~/web/components/ErrorBoundary';
import FittedFallbackComponent from '~/web/components/ErrorBoundary/fallbackComponent';

const Boundary = getErrorBoundary(true);

export const EditorErrorBoundary = ({
  children,
  editor,
}: {
  children: ReactNode;
  editor: BufferEditor;
}): JSX.Element => {
  const onError = useCallback(
    updateSlateErrorData({
      context: 'EditorErrorBoundary',
      editor,
    }),
    [editor]
  );
  return (
    <Boundary fallbackComponent={FittedFallbackComponent} onError={onError}>
      {children}
    </Boundary>
  );
};
